/**
 * 头部导航
 */
export default {
  signIn: 'サインイン',
  signOut: 'サインアウト',
}
